export default `---
slug: potential-talent
title: "Potential Talent"
year: 2023
category: personal
featured: false
tags: [Python, NLP, word2vec, TF-IDF, SpaCy, Fuzzy Matching, Apziva]
thumbnail: /images/projects/15_vecho_ScaPy.png
description: "NLP to rank candidates by similarity to an ideal LinkedIn profile — fuzzy matching, TF-IDF, word2vec and POS tagging. (Doing NLP with Claude's help is so ironic.)"
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the third project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with Claude (by this time I switched), who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/Potential-Talent)) covered Natural Language Processing, in particular I needed to rank individuals based on their LinkedIn job title and location similarity with the ideal candidate's information.
(*doing NLP with the help of Claude is so ironic*).

![Student in NL doing NLP](/images/projects/15_vecho_ScaPy.png)

Since it was a didactical project, and it was my first time experimenting with NLP, I tried to explore and try as many approaches as possible, to scratch the surface of the Natural Language Processing field.

- First, I preprocessed the job titles with tokenization, stop words removal, acronym expansion and lemmization, implemented with the nltk python library
- Then, I ranked the strings based on Fuzzy Matching implemented with TheFuzz python library
- I also ranked the strings based on Bag Of Words, N-grams and TF-IDF similarities using sklearn python library
- Finally, out of curiosity, I processed the job titles based on POS tags and semantic dependencies, then ranked the strings based on the pre-trained word2vec similarity implemented by SpaCy python library
- *In hindsight, I should have tried LLMs to get the job done (talking about using a bazuka to kill a fly), but luckily I played with the big transformers models later on.*

It goes without saying that I did the project in Python, using Google computing power (*Colab one love*).
I would love to tell you more about the project, but I don't really remember and I am too lazy to check the Jupyter notebook - it is linked at the top, if you are curious go check it out!
`;
